import { useEffect, useState } from "react";
import { TrendingUp, Bookmark, RefreshCw, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

const VIBE = { green: { label: "chill", cls: "pill-green" }, amber: { label: "notice", cls: "pill-amber" }, red: { label: "check in", cls: "pill-red" } };

export default function Trends() {
  const [digest, setDigest] = useState(null);
  const [favs, setFavs] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => { setLoading(true); api.get("/digest").then(({ data }) => { setDigest(data); setFavs(data.favorites || []); }).catch(() => {}).finally(() => setLoading(false)); };
  useEffect(() => { load(); }, []);

  const isFav = (term) => favs.some((f) => f.term === term);
  const toggle = async (item) => {
    try { const { data } = await api.post("/digest/favorite", { item }); setFavs(data.favorites); toast.success(isFav(item.term) ? "Removed from favourites" : "Saved to favourites"); }
    catch { toast.error("Couldn't update"); }
  };

  const when = digest?.generated_at ? new Date(digest.generated_at).toLocaleDateString(undefined, { month: "long", day: "numeric", year: "numeric" }) : "";

  return (
    <div className="space-y-6" data-testid="trends-page">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="flex items-center gap-2">
          <TrendingUp size={22} style={{ color: "var(--accent)" }} />
          <h1 className="font-serif text-[28px] sm:text-[34px] font-semibold">This week's trends</h1>
        </div>
        <button className="btn btn-ghost" onClick={load} data-testid="trends-refresh"><RefreshCw size={15} /> Refresh</button>
      </div>

      {loading ? <p className="text-sm" style={{ color: "var(--text-muted)" }}>Loading…</p> : (
        <>
          {digest?.intro && <p className="text-[18px]" style={{ color: "var(--text-muted)" }}>{digest.intro} {when && <span className="text-sm">· updated {when}</span>}</p>}

          <div className="grid sm:grid-cols-2 xl:grid-cols-3 gap-4">
            {(digest?.items || []).map((it, i) => (
              <div key={i} className="dk-card p-6 space-y-3 flex flex-col" data-testid="trend-card">
                <div className="flex items-start justify-between gap-2">
                  <h3 className="font-serif text-[20px] font-medium">{it.term}</h3>
                  <button className={`btn btn-ghost px-2 ${isFav(it.term) ? "text-[#B04A39]" : ""}`} onClick={() => toggle(it)} data-testid={`trend-fav-${i}`} aria-label="Favourite">
                    <Bookmark size={18} fill={isFav(it.term) ? "currentColor" : "none"} />
                  </button>
                </div>
                <p className="text-[15px] flex-1" style={{ color: "var(--text)" }}>{it.note}</p>
                <span className={`badge-soft ${VIBE[it.vibe || "green"].cls} self-start`}>{VIBE[it.vibe || "green"].label}</span>
              </div>
            ))}
          </div>

          <div className="dk-card p-6" data-testid="trends-favorites">
            <div className="flex items-center gap-2 mb-3"><Bookmark size={18} style={{ color: "var(--accent)" }} /><h2 className="font-serif text-[20px] font-medium">Your saved words</h2></div>
            {favs.length === 0 ? (
              <p className="text-sm" style={{ color: "var(--text-muted)" }}>Tap the bookmark on any word to keep it here for quick reference.</p>
            ) : (
              <div className="grid sm:grid-cols-2 gap-3">
                {favs.map((f, i) => (
                  <div key={i} className="rounded-xl p-4 flex items-start justify-between gap-2" style={{ background: "var(--card-alt)" }}>
                    <div><p className="font-medium">{f.term}</p><p className="text-xs mt-0.5" style={{ color: "var(--text-muted)" }}>{f.note}</p></div>
                    <button className="btn btn-ghost px-2 text-[#B04A39]" onClick={() => toggle(f)} aria-label="Remove"><Bookmark size={16} fill="currentColor" /></button>
                  </div>
                ))}
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
}
